import I18n from 'I18n';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/transitional/components/View';
import { UserListItem } from './UserListItem';
import { GroupListItem } from './GroupListItem';
import { TeamMembersPopover } from './TeamMembersPopover';
import { PRIVATE, PUBLIC, TEAM } from '../../getCheckedOptionFromView';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { useFetchPortalDetails } from '../../hooks/useFetchPortalDetails';
import { useFetchPortalUserCount } from '../../hooks/useFetchPortalUserCount';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PrivateContent = () => {
  const {
    data: currentUser,
    loading,
    error
  } = useCurrentUser();
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "200px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "medium"
      })
    });
  }
  if (error || !currentUser) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "viewsManagement.modals.manageSharing.sharingPanel.unexpectedError"
    });
  }
  return /*#__PURE__*/_jsx(UserListItem, {
    displayName: currentUser.displayName,
    email: currentUser.email
  });
};
const TeamContent = ({
  team
}) => {
  const {
    data: currentUser,
    loading,
    error
  } = useCurrentUser();
  if (loading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "200px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "medium"
      })
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [error || !currentUser ? /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.sharingPanel.unexpectedError"
      })
    }) : /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(UserListItem, {
        displayName: currentUser.displayName,
        email: currentUser.email
      })
    }), team && /*#__PURE__*/_jsx(GroupListItem, {
      avatarInitial: team.name.charAt(0).toUpperCase(),
      name: team.name,
      subtitle: /*#__PURE__*/_jsx(TeamMembersPopover, {
        teamName: team.name,
        userIds: team.userIds
      })
    })]
  });
};
const EveryoneContent = () => {
  const {
    data: currentUser,
    loading: userLoading,
    error
  } = useCurrentUser();
  const {
    data: portalDetails,
    loading: portalLoading
  } = useFetchPortalDetails();
  const {
    data: portalUserCount,
    loading: userCountLoading
  } = useFetchPortalUserCount();
  if (userLoading || portalLoading || userCountLoading) {
    return /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      justifyContent: "center",
      blockSize: "200px",
      children: /*#__PURE__*/_jsx(LoadingSpinner, {
        size: "medium"
      })
    });
  }
  const portalName = (portalDetails === null || portalDetails === void 0 ? void 0 : portalDetails.accountName) || I18n.text('viewsManagement.modals.manageSharing.sharingPanel.portalName');
  const portalInitial = portalName.charAt(0).toUpperCase();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [error || !currentUser ? /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.sharingPanel.unexpectedError"
      })
    }) : /*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "400",
      children: /*#__PURE__*/_jsx(UserListItem, {
        displayName: currentUser.displayName,
        email: currentUser.email
      })
    }), /*#__PURE__*/_jsx(GroupListItem, {
      avatarInitial: portalInitial,
      name: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.sharingPanel.allPortalUsers",
        options: {
          portalName
        }
      }),
      subtitle: portalUserCount ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "viewsManagement.modals.manageSharing.sharingPanel.portalUsersCount",
        options: {
          count: portalUserCount
        }
      }) : null
    })]
  });
};
export const SharingUserDisplayPanel = ({
  checkedOption,
  team
}) => /*#__PURE__*/_jsx(Box, {
  grow: 1,
  shrink: 1,
  basis: "0",
  children: /*#__PURE__*/_jsx(View, {
    borderInlineStartWidth: "100",
    borderInlineStartStyle: "solid",
    borderInlineStartColor: "border-core-subtle",
    minBlockSize: "300px",
    blockSize: "100%",
    "data-test-id": "sharing-user-display-panel",
    children: /*#__PURE__*/_jsxs(Box, {
      paddingBlockStart: "600",
      paddingInline: "400",
      paddingBlockEnd: "400",
      grow: 1,
      overflow: "auto",
      maxBlockSize: "350px",
      children: [checkedOption === PRIVATE && /*#__PURE__*/_jsx(PrivateContent, {}), checkedOption === TEAM && /*#__PURE__*/_jsx(TeamContent, {
        team: team
      }), checkedOption === PUBLIC && /*#__PURE__*/_jsx(EveryoneContent, {})]
    })
  })
});